import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      '&:hover': {
        backgroundColor: COLORS.neutral.silver,
      },
    },
    cell: {
      padding: theme.spacing(1.5),
    },
    cellText: {
      fontSize: theme.typography.pxToRem(12),
      lineHeight: theme.typography.pxToRem(24),
    },
    switch: {
      display: 'flex',
      margin: 'auto',
    },
    track: {
      background: COLORS.neutral.mediumGray,
      borderColor: COLORS.neutral.mediumGray,
    },
    statusCell: {
      display: 'flex',
      alignItems: 'center',
      '&$connected': {
        '& $dotIcon': {
          color: COLORS.success.active,
        },
      },
    },
    connected: {},
    dotIcon: {
      width: theme.spacing(1),
      height: theme.spacing(1),
      color: COLORS.error.light,
      marginRight: theme.spacing(1),
    },
  }),
  { name: 'AccountsTable' }
);
